import { GroupsPage } from 'features/groups';

export const TechOperatorGroupsPage: React.FC = () => <GroupsPage />;
